const listaDeTiposStatus = (state) => {
    return state.items;
}

const loadingTipoStatus = (state) => {
    return state.carregando
}

export {
    listaDeTiposStatus,
    loadingTipoStatus
}